// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const silicobra: PokeData = {
  "id": 843,
  "name": "silicobra",
  "height": 22,
  "weight": 76,
  "base_experience": 63,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "slam",
    "sand-attack",
    "headbutt",
    "wrap",
    "dig",
    "minimize",
    "glare",
    "sandstorm",
    "sand-tomb",
    "coil",
    "bulldoze",
    "brutal-swing"
  ],
  "moves": [
    "headbutt",
    "sandstorm",
    "earth-power",
    "earthquake",
    "bone-throw",
    "mud-bomb",
    "mud-shot",
    "rototiller",
    "magnitude",
    "bonemerang",
    "mud-slap",
    "fissure"
  ],
  "evolution_chain": {
    "id": 443,
    "item": null,
    "species": [
      {
        "name": "silicobra",
        "order": 843,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sandaconda",
        "order": 844,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 843,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 57.25,
    "speed": 46,
    "ability_power": 57
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
